// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var SwitchToAgentProfileDialogMutation_graphql = require("../../__generated__/SwitchToAgentProfileDialogMutation_graphql.bs.js");

var convertVariables = SwitchToAgentProfileDialogMutation_graphql.Internal.convertVariables;

var convertResponse = SwitchToAgentProfileDialogMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = SwitchToAgentProfileDialogMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, SwitchToAgentProfileDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, SwitchToAgentProfileDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function SwitchToAgentProfileDialog(props) {
  var onDismiss = props.onDismiss;
  var isOpen = props.isOpen;
  var match = use();
  var mutate = match[0];
  var match$1 = React.useState(function () {
        return "Idle";
      });
  var setSubmissionStatus = match$1[1];
  var submissionStatus = match$1[0];
  var match$2 = SystemMessages.useSystemMessages();
  var addMessage = match$2.addMessage;
  if (!isOpen && submissionStatus !== "Idle") {
    setSubmissionStatus(function (param) {
          return "Idle";
        });
  }
  var handleSuccess = function () {
    onDismiss();
    addMessage(SystemMessages.Message.make(undefined, "info", "Your team profile has been replaced with an agent profile.", 5000, undefined, undefined));
  };
  var submit = function () {
    setSubmissionStatus(function (param) {
          return "Loading";
        });
    return mutate(undefined, undefined, undefined, undefined, (function (param, param$1) {
                  var switchToAgentMarketingProfile = param.switchToAgentMarketingProfile;
                  if (switchToAgentMarketingProfile !== undefined) {
                    if (switchToAgentMarketingProfile.__typename === "SwitchedToAgentMarketingProfile") {
                      return handleSuccess();
                    } else {
                      return setSubmissionStatus(function (param) {
                                  return "SubmissionError";
                                });
                    }
                  } else {
                    return setSubmissionStatus(function (param) {
                                return "SubmissionError";
                              });
                  }
                }), (function (param) {
                  setSubmissionStatus(function (param) {
                        return "SubmissionError";
                      });
                }), undefined);
  };
  var tmp;
  switch (submissionStatus) {
    case "Idle" :
    case "Loading" :
        tmp = null;
        break;
    case "SubmissionError" :
        tmp = JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Alert.$$Error.make, {
                    title: "There was an error updating your account. Please try again"
                  })
            });
        break;
    
  }
  return JsxRuntime.jsx(DialogV5.make, {
              title: "Switch to agent profile",
              isOpen: isOpen,
              ariaLabel: "Switch to agent profile",
              onDismiss: onDismiss,
              size: "Large",
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: "Switching to an agent profile will replace your team profile with a page designed for a single agent."
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "This action will also change the URL of your profile."
                                  })
                            ],
                            className: "flex flex-col gap-3"
                          }),
                      tmp,
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                    onClick: (function (param) {
                                        onDismiss();
                                      }),
                                    disabled: submissionStatus === "Loading",
                                    size: "medium",
                                    children: "Cancel"
                                  }),
                              JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
                                    onClick: (function (param) {
                                        submit();
                                      }),
                                    disabled: submissionStatus === "Loading",
                                    children: "Switch to agent profile"
                                  })
                            ],
                            className: "flex gap-4 justify-end"
                          })
                    ],
                    className: "flex flex-col gap-6"
                  })
            });
}

var make = SwitchToAgentProfileDialog;

exports.Mutation = Mutation;
exports.make = make;
/* commitMutation Not a pure module */
